export const costs = [
  'Sleepless nights translating complex mechanical engineering concepts',
  'Improvised explanations from disorganized technical materials',
  "Disconnected colleagues who don't see mechanical engineering relevance",
  'Weekends building technical references and design analyses from scratch',
  'No clear answers when professionals ask technical questions',
];
